<template>
  <div ref="info" class="info ">
    <el-form ref="infoForm" :model="infoForm" :rules="rules" class="info-form" label-width="180px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业全称：" prop="name">
            <el-input v-model="infoForm.name" placeholder="请输入企业全称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="社会统一信用代码：" prop="code">
            <el-input v-model="infoForm.code" placeholder="请输入社会统一信用代码"></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="12">
              <div class="flex align-center">
                  <el-form-item class="flex-sub" label="注册地址：">
                      <el-select
                          v-model="infoForm.register_address_city"
                          style="width: 100%"
                          placeholder="请选择地区">
                          <el-option label="北京市" value="北京市"></el-option>
                          <el-option label="其他地区" value="其他地区"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item class="flex-sub margin-left" label-width="0" prop="registerAddress"  v-if="infoForm.register_address_city === '北京市'" >
                      <el-select
                          v-model="infoForm.registerAddress"
                          style="width: 100%"
                          placeholder="请选择注册地址">
                          <el-option
                              v-for="item in address"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </div>
          </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址：" prop="registerAddressDetail">
            <el-input v-model="infoForm.registerAddressDetail" placeholder="请输入详细地址"></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="24"  v-if="infoForm.register_address_city !== '北京市'">
              <el-form-item label="入会情况说明：" prop="register_address_file">
                  <div class="flex align-center">
                      <el-upload
                          ref="upload4"
                          :action="udhost + '/api/index/upload'"
                          :data="fileData"
                          :file-list="infoForm.register_address_file"
                          :name="'file'"
                          :on-preview="handlePreview"
                          :on-remove="handleRemove4"
                          :on-success="handleAvatarSuccess4">
                          <div class="flex align-center">
                              <el-button type="primary">
                                  + 点击上传
                              </el-button>

                          </div>
                      </el-upload>
                      <el-link
                          :href="showhost +'/static/file/入会情况说明.docx'"
                          :underline="false"
                          class="margin-left"
                          target="_blank"
                          type="primary">
                          点击下载入会情况说明
                      </el-link>
                  </div>
              </el-form-item>
          </el-col>
        <el-col :span="12">
          <el-form-item label="邮寄地址(经营地址)：" prop="mailAddress">
            <div class="flex align-center">
                <el-select
                    v-model="infoForm.post_address_city"
                    class="flex-sub"
                    placeholder="请选择地区" disabled>
                    <el-option label="北京市" value="北京市"></el-option>
                    <el-option label="其他地区" value="其他地区"></el-option>
                </el-select>
                <el-select
                    v-if="infoForm.post_address_city === '北京市'"
                    v-model="infoForm.mailAddress" class="flex-sub margin-left-sm" placeholder="请选择邮寄地址(经营地址)">
                <el-option
                  v-for="item in address"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址：" prop="mailAddressDetail">
            <el-input v-model="infoForm.mailAddressDetail" placeholder="请输入详细地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位性质：" prop="nature">
            <el-select v-model="infoForm.nature" class="w-all" placeholder="请选择单位性质">
              <el-option
                v-for="item in nature"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员等级：" prop="level">
            <el-select v-model="infoForm.level" class="w-all" placeholder="请选择会员等级">
              <el-option
                v-for="item in level"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请时间：" prop="applyTime">
            <el-date-picker
              v-model="infoForm.applyTime"
              class="w-all"
              placeholder="请选择申请时间"
              type="date">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否新会员：" prop="newMember">
            <el-select v-model="infoForm.newMember" class="w-all" placeholder="请选择是否新会员">
              <el-option
                v-for="item in newMember"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="注册资本（万元）：" prop="memberCapital">
              <el-input
                  v-model="infoForm.memberCapital"
                  type="number"
                  placeholder="请输入注册资本（万元）"
              ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="会员分类：" prop="memberType">
            <el-select v-model="infoForm.memberType" class="w-all" placeholder="请选择会员分类">
              <el-option
                v-for="item in memberType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item v-if="infoForm.memberType === 1" label="服务类别(可多选)：" prop="moreType">
            <el-select v-model="infoForm.moreType" class="w-all" :multiple-limit="6" multiple placeholder="请选择服务类别">
              <el-option
                v-for="item in supply"
                :key="item.value"
                :label="item.label +'：'+ item.desc"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item v-if="infoForm.memberType === 2" label="服务类别(可多选)：" prop="moreType">
            <el-select v-model="infoForm.moreType" class="w-all" :multiple-limit="6" multiple placeholder="请选择服务类别">
              <el-option
                v-for="item in demand"
                :key="item.value"
                :label="item.label  +'：'+ item.desc"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="专委会职务：" prop="post">
            <el-select v-model="infoForm.post" class="w-all" filterable multiple placeholder="请选择专委会职务">
              <el-option
                v-for="item in committeeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人代表姓名：" prop="legalPerson">
            <el-input v-model="infoForm.legalPerson" placeholder="请输入法人代表姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人代表电话：" prop="legalPersonPhone">
            <el-input v-model="infoForm.legalPersonPhone" placeholder="请输入法人代表电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人姓名：" prop="contacts">
            <el-input v-model="infoForm.contacts" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人电话：" prop="contactsPhone">
            <el-input v-model="infoForm.contactsPhone" placeholder="请输入联系人电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人邮箱：" prop="contactsEmail">
            <el-input v-model="infoForm.contactsEmail" placeholder="请输入联系人邮箱"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入会介绍人：" prop="introducePerson">
            <el-input v-model="infoForm.introducePerson" placeholder="请输入入会介绍人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="介绍人会员等级：" prop="introducePersonLevel">
            <el-select v-model="infoForm.introducePersonLevel" class="w-all"
                       placeholder="请选择介绍人会员等级">
              <el-option
                v-for="item in introduce"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="公司简介：" prop="desc">
            <el-input v-model="infoForm.desc" :rows="5" placeholder="请输入公司简介" type="textarea"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="营业范围：" prop="business">
            <el-input v-model="infoForm.business" :rows="5" placeholder="请输入营业范围"
                      type="textarea"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="业绩情况：" prop="performance">
            <el-input v-model="infoForm.performance" :rows="5" placeholder="请输入业绩情况"
                      type="textarea"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="营业执照：" prop="license">
            <el-upload
              ref="upload1"
              :action="udhost + '/api/index/upload'"
              :data="fileData"
              :file-list="fileList"
              :limit="1"
              :name="'file'"
              :on-exceed="handleExceed"
              :on-preview="handlePreview"
              :on-remove="handleRemove1"
              :on-success="handleAvatarSuccess1"
              accept="image/*"
            >
              <div class="flex align-center">
                <el-button plain type="primary"> + 点击上传营业执照</el-button>
                <p class="margin-left">备注：请上传png/jpg/jpeg等格式的图片</p>
              </div>
            </el-upload>
            <el-image
              v-if="infoForm.license && infoForm.license.url"
              :fit="'scale-down'"
              :preview-src-list="[showhost + infoForm.license.url]"
              :src="showhost + infoForm.license.url"
              style="width: 200px; height: 200px;">
            </el-image>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="会员承诺书：" prop="promise">
            <div class="flex align-center">
              <el-upload
                ref="upload2"
                :action="udhost + '/api/index/upload'"
                :data="fileData"
                :file-list="fileList2"
                :limit="1"
                :name="'file'"
                :on-exceed="handleExceed"
                :on-preview="handlePreview"
                :on-remove="handleRemove2"
                :on-success="handleAvatarSuccess2"
                accept="image/*"
                class="flex-sub"
              >
                <div class="flex align-center">
                  <el-button plain type="primary"> + 点击上传会员承诺书</el-button>
                  <p class="margin-left">备注：请上传png/jpg/jpeg等格式的图片</p>
                </div>
              </el-upload>
              <el-link v-if="infoForm.memberType === 1" :href="showhost+'/static/file/北京消防协会单位会员承诺书（供给侧会员）.docx'"
                       :underline="false"
                       class="margin-left" target="_blank"
                       type="primary">
                点击下载会员承诺书
              </el-link>
              <el-link v-if="infoForm.memberType === 2" :href="showhost+'/static/file/北京消防协会单位会员承诺书（需求侧会员）.docx'"
                       :underline="false"
                       class="margin-left" target="_blank"
                       type="primary">
                点击下载会员承诺书
              </el-link>
            </div>
            <el-image
              v-if="infoForm.promise && infoForm.promise.url"
              :fit="'scale-down'"
              :preview-src-list="[showhost + infoForm.promise.url]"
              :src="showhost + infoForm.promise.url"
              style="width: 200px; height: 200px;">
            </el-image>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="其他附件：">
            <el-upload
              ref="upload3"
              :action="udhost + '/api/index/upload'"
              :data="fileData"
              :file-list="fileList3"
              :name="'file'"
              :on-preview="handlePreview"
              :on-remove="handleRemove3"
              :on-success="handleAvatarSuccess3"
              multiple
            >
              <el-button plain type="primary"> + 点击其他附件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label-width="0">
            <div class="flex align-center justify-around">
              <el-button class="w-20" type="primary" @click="submitForm('infoForm')">提交</el-button>
            </div>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  address,
  demand,
  introduce,
  level,
  memberType,
  nature,
  newMember,
  optionList,
  supply,
  zhDate
} from "@/utils/utils";
import {SHOWHOST, UDHOST} from '@/config/index'
import {getInformation} from "@/api/member";
import {userCompanyEdit} from "@/api/admin";
import {getCommittee} from "@/api/common";

export default {
  name: "info",
  data() {
    return {
      address: optionList(false, address),
      nature: optionList(false, nature),
      level: optionList(false, level),
      newMember: optionList(true, newMember),
      memberType: optionList(false, memberType),
      supply: optionList(false, supply),
      demand: optionList(false, demand),
      introduce: optionList(false, introduce),
      committeeList: [],
      fileList: [],
      fileList2: [],
      fileList3: [],
      infoForm: {
        name: '',
        code: '',
          register_address_city: '北京市',
        registerAddress: '',
        registerAddressDetail: '',
          post_address_city: '北京市',
        mailAddress: '',
        mailAddressDetail: '',
        nature: '',
        level: '',
        applyTime: null,
        newMember: '',
        memberType: '',
        moreType: '',
        post: '',
        legalPerson: '',
        legalPersonPhone: '',
        contacts: '',
        contactsPhone: '',
        contactsEmail: '',
        introducePerson: '',
        introducePersonLevel: '',
        desc: '',
        business: '',
        performance: '',
        license: '',
        promise: '',
        other: [],
        register_address_file:[],
        memberCapital: ''
      },
      rules: {
        name: [{required: true, message: '请输入企业全称', trigger: 'blur'}],
          memberCapital: [{required: true, message: '请输入注册资本（万元）', trigger: 'blur'}],
        // code: [{required: true, message: '请输入社会统一信用代码', trigger: 'blur'}],
        // registerAddress: [{required: true, message: '请选择注册地址', trigger: 'change'}],
        // registerAddressDetail: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
        //   register_address_file: [{required: true, message: '请上传入会情况说明', trigger: 'blur'}],
        // mailAddress: [{required: true, message: '请选择邮寄地址(经营地址)', trigger: 'change'}],
        // mailAddressDetail: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
        // nature: [{required: true, message: '请选择单位性质', trigger: 'change'}],
        // level: [{required: true, message: '请选择会员等级', trigger: 'change'}],
        // applyTime: [{type: 'date', required: true, message: '请选择申请时间', trigger: 'change'}],
        // newMember: [{required: true, message: '请选择是否新会员', trigger: 'change'}],
        // memberType: [{required: true, message: '请选择会员分类', trigger: 'change'}],
        // moreType: [{required: true, message: '请选择服务类别', trigger: 'change'}],
        // post: [{required: true, message: '请输入专委会职务', trigger: 'blur'}],
        // legalPerson: [{required: true, message: '请输入法人代表姓名', trigger: 'blur'}],
        // legalPersonPhone: rules.phone,
        // contacts: [{required: true, message: '请输入联系人姓名', trigger: 'blur'}],
        // contactsPhone: rules.phone,
        // contactsEmail: [{required: true, message: '请输入联系人电子邮箱', trigger: 'blur'},
        //   {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}],
        // introducePerson: [{required: true, message: '请输入入会介绍人', trigger: 'blur'}],
        // introducePersonLevel: [{required: true, message: '请选择介绍人会员等级', trigger: 'change'}],
        // desc: [{required: true, message: '请输入公司简介', trigger: 'blur'}],
        // business: [{required: true, message: '请输入营业范围', trigger: 'blur'}],
        // performance: [{required: true, message: '请输入业绩情况', trigger: 'blur'}],
        // license: [{required: true, message: '请上传营业执照', trigger: 'change'}],
        // promise: [{required: true, message: '请上传会员承诺书', trigger: 'change'}],
      },
      state: 0,  // 0 待提交  // 1已提交   // 2审核通过  // 3审核拒绝
    }
  },
  computed: {
    udhost() {
      return UDHOST
    },
    showhost() {
      return SHOWHOST
    },

    fileData() {
      return {
        // token: this.user.token
      };
    },
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", '/admin/member', "会员管理  / 会员信息编辑", true, 'icon-yonghu');
    this.getCommittee()
    this.getDetail()
  },
  components: {},
  methods: {
    //  获取专职
    async getCommittee() {
      let _data = await getCommittee()
      this.committeeList = _data.data
    },
    //  获取基本信息
    async getDetail() {
      let _data = await getInformation(this.$route.params.id)
      if (_data.data) {
        this.infoForm = {
          name: _data.data.company_name,
          code: _data.data.company_code,
            register_address_city: _data.data.register_address_city || this.infoForm.register_address_city,
          registerAddress: _data.data.register_address_county,
          registerAddressDetail: _data.data.register_address_detail,
            post_address_city: _data.data.post_address_city || this.infoForm.post_address_city,
          mailAddress: _data.data.post_address_county,
          mailAddressDetail: _data.data.post_address_detail,
          memberCapital: _data.data.capital ? _data.data.capital : '',
          nature: _data.data.company_type_id ? _data.data.company_type_id : '',
          level: _data.data.company_level_id ? _data.data.company_level_id : '',
          applyTime: _data.data.apply_time ? new Date(_data.data.apply_time) : '',
          newMember: _data.data.is_new !== '' ? _data.data.is_new : '',
          memberType: _data.data.member_type ? _data.data.member_type : '',
          moreType: _data.data.member_type_detail_id ? _data.data.member_type_detail_id.split(',').map(Number) : [],
          post: _data.data.special_job ? _data.data.special_job.split(',').map(Number) : [],
          legalPerson: _data.data.legal_person_name,
          legalPersonPhone: _data.data.legal_person_tel,
          contacts: _data.data.tel_name,
          contactsPhone: _data.data.tel_number,
          contactsEmail: _data.data.tel_email,
          introducePerson: _data.data.introducer,
          introducePersonLevel: _data.data.introducer_level_id ? _data.data.introducer_level_id : '',
          desc: _data.data.company_desc,
          business: _data.data.business_range,
          performance: _data.data.achievement_desc,
          license: _data.data.business_license ? JSON.parse(_data.data.business_license) : '',
          promise: _data.data.member_commitment ? JSON.parse(_data.data.member_commitment) : '',
          other: JSON.parse(_data.data.other_file),
            register_address_file: _data.data.register_address_file ? JSON.parse(_data.data.register_address_file) : []
        }
        this.state = _data.data.state
        if (_data.data.state !== 0) this.infoForm.agree = true
        this.fileList = [JSON.parse(_data.data.business_license)]
        this.fileList2 = [JSON.parse(_data.data.member_commitment)]
        this.fileList3 = JSON.parse(_data.data.other_file)

      } else {
        this.infoForm.name = this.user.user_name
      }
      this.$refs.infoForm.clearValidate()
    },
    //  提交
    async sureSubmut() {
      if (this.infoForm.moreType.length > 6) return this.$message.error('服务类别最多可选择6项')
      let _state = await userCompanyEdit(this.infoForm.name,
        this.infoForm.code,
        this.infoForm.register_address_city,
        this.infoForm.registerAddress,
        this.infoForm.registerAddressDetail,
        this.infoForm.post_address_city,
        this.infoForm.mailAddress,
        this.infoForm.mailAddressDetail,
        this.infoForm.nature,
        this.infoForm.level,
        this.infoForm.applyTime ? zhDate(this.infoForm.applyTime) : '',
        this.infoForm.newMember,
        this.infoForm.memberType,
        this.infoForm.moreType ? this.infoForm.moreType.join(',') : '',
        this.infoForm.post.join(','),
        this.infoForm.legalPerson,
        this.infoForm.legalPersonPhone,
        this.infoForm.contacts,
        this.infoForm.contactsPhone,
        this.infoForm.contactsEmail,
        this.infoForm.introducePerson,
        this.infoForm.introducePersonLevel,
        this.infoForm.desc,
        this.infoForm.business,
        this.infoForm.performance,
        this.infoForm.license ? JSON.stringify(this.infoForm.license) : '',
        this.infoForm.promise ? JSON.stringify(this.infoForm.promise) : '',
        JSON.stringify(this.infoForm.other),
        JSON.stringify(this.infoForm.register_address_file),
        this.infoForm.memberCapital,
        this.$route.params.id)
      if (_state.status === 200) {
        this.$message.success(_state.msg)
        this.getDetail()
      }

    },
    //  提交前验证
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sureSubmut()
        } else {
          this.$message.error('信息填写不完整，请检查修改！')
          this.$nextTick(() => {
            this.$refs.info.scrollTo(0, 0);
          });
        }
      });

    },
    //  删除上传文件
    handleRemove1() {
      this.infoForm.license = null
      this.fileList = []
    },
    handleRemove2() {
      this.infoForm.promise = null
      this.fileList2 = []
    },
    handleRemove3(file, fileList) {
      console.log(file)
      this.infoForm.other = fileList
      this.fileList3 = fileList
    },
    //  上传成功
    handleAvatarSuccess1(res, file) {
      if (res.status === 200) {
        this.infoForm.license = {
          name: file.name,
          url: res.url
        }
        this.fileList = [{
          name: file.name,
          url: res.url
        }]
      } else {
        this.$message.error(res.info)
        this.$refs['upload'].clearFiles()
      }
    },
    handleAvatarSuccess2(res, file) {
      if (res.status === 200) {
        this.infoForm.promise = {
          name: file.name,
          url: res.url
        }
        this.fileList2 = [{
          name: file.name,
          url: res.url
        }]
      } else {
        this.$message.error(res.info)
        this.$refs['upload'].clearFiles()
      }
    },
    handleAvatarSuccess3(res, file) {
      if (res.status === 200) {
        this.infoForm.other.push(
          {
            name: file.name,
            url: res.url
          }
        )
        this.fileList3 = this.infoForm.other
      } else {
        this.$message.error(res.info)
        this.$refs['upload'].clearFiles()
      }
    },
      handleRemove4(file, fileList) {
          this.infoForm.register_address_file = fileList
      },
      handleAvatarSuccess4(res, file) {
          if (res.status === 200) {
              this.infoForm.register_address_file.push(
                  {
                      name: file.name,
                      url: res.url
                  }
              )
          } else {
              this.$message.error(res.info)
              this.$refs['upload4'].clearFiles()
          }
      },
    // 上传失败
    handleExceed() {
      this.$message.error('请先删除当前已上传的文件')
    },
    //上传文件预览
    handlePreview(file) {
      window.open(file.url)
    },
  },
  filters: {},
  watch: {},
}
</script>

<style lang="scss" scoped>
.info {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  height: calc(100vh - 180px);
  overflow: auto;

  .xieyi {
    font-size: 14px;
    line-height: 24px;
    padding-left: 50px;
    color: #666;

    p {
      text-indent: 32px;
    }
  }

  .agree {
    width: 220px;
    margin: 0 auto;
  }
}
</style>
